module.exports = __webpack_public_path__ + "img/festa2.4bc4b61f.png";